import { render, staticRenderFns } from "./GigStatusBadge.htm?vue&type=template&id=37935a36&"
import script from "./GigStatusBadge.ts?vue&type=script&lang=js&"
export * from "./GigStatusBadge.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports